/**
 * Aqui se incluyen las utilidades para ejecutar funciones.
 */

 import utils from '@/builder/utils'

let funcs = {
}

/**
 * Permite ejecutar una expresion. Se usa sobre todo por parte de la API de cliente para ejecutar event handlers.
 * El builder utiliza el otro metodo.
 *
 * @param {*} expression funcion a ejecutar como cadena de texto.
 * @param {*} bindContext El objeto que se usara como this durante la ejecucion
 * @returns
 */
 funcs.executeJSSync = (expression, bindContext) => {
    if (!expression) return
    let eventHandler = new Function(expression);
    try {
        let r = eventHandler.bind(bindContext)();
        return r
    } catch(err) {
        window.console.error('executeJSSync::Error ejecuntando js')
        window.console.error('Componente: ', (bindContext ||{}).name)
        window.console.error('código:', expression);

        throw err
    }

}

funcs.executeJS = (expression, bindContext) => {
    if (!expression) return
    const AsyncFunction = Object.getPrototypeOf(async function(){}).constructor;
    let eventHandler = new AsyncFunction(expression);

    try {
        let r = eventHandler.bind(bindContext)();
        return r
    } catch(err) {
        window.console.error('executeJS::Error ejecuntando js')
        window.console.error('Componente: ', (bindContext ||{}).name)
        window.console.error('código:', expression);

        throw err
    }
}


/**
 * Permite ejecutar un handler - como por ejemplo, SelectInput.onChange.
 * Esto acepta expresiones js o definiciones de funcion. La segunda
 * puede ser necesaria si se necesita recibir algun parametro.
 *
 *      { window.console.log(this); }
 *
 *  y tambien
 *
 *      (e) => { window.console.log(this)}
 *
 * @param {*} js
 * @param {*} bindContext
 * @returns
 */
funcs.executeHandler = (js, bindContext, ...params) => {
    if(!js) return

    try {
        let boundFN = function () {
            return eval(js);
        }.call(bindContext, ...params);
        return utils.isFunction(boundFN) ?  boundFN.call(bindContext, ...params): boundFN
    } catch(err) {
        window.console.error('executeHandler::Error ejecuntando codigo de evento')
        window.console.table([{
            'Mensaje error': err,
            'Componente': (bindContext ||{}).name,
            'Funcion evaluada': js
        }]);

        window.console.error('parámetros:', ...params);
        window.console.error('error:', err);
        throw err

    }
}

// let str = "() => { console.log('this', this); } "
// funcs.executeHandler(str, { x : 6})
// this> { x: 6 }

export default funcs